// Action Type for Loyalty List and CRUD

// Loyalty List
export const GET_LOYALTY_LIST = "GET_LOYALTY_LIST";
export const GET_LOYALTY_LIST_SUCCESS = "GET_LOYALTY_LIST_SUCCESS";
export const GET_LOYALTY_LIST_ERROR = "GET_LOYALTY_LIST_ERROR";

// Loalty get single customer data post request
export const LOYALTY_SINGLE_CUSTOMER_DATA = "LOYALTY_SINGLE_CUSTOMER_DATA";
export const LOYALTY_SINGLE_CUSTOMER_DATA_SUCCESS =
  "LOYALTY_SINGLE_CUSTOMER_DATA_SUCCESS";
export const LOYALTY_SINGLE_CUSTOMER_DATA_ERROR =
  "LOYALTY_SINGLE_CUSTOMER_DATA_ERROR";

// Loyalty Single Customer balance Search
export const LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH =
  "LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH";
export const LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_SUCCESS =
  "LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_SUCCESS";
export const LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_ERROR =
  "LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_ERROR";

// GET Loyalty Balances List
export const GET_LOYALTY_BALANCES_LIST = "GET_LOYALTY_BALANCES_LIST";
export const GET_LOYALTY_BALANCES_LIST_SUCCESS =
  "GET_LOYALTY_BALANCES_LIST_SUCCESS";
export const GET_LOYALTY_BALANCES_LIST_ERROR =
  "GET_LOYALTY_BALANCES_LIST_ERROR";

// Get Loyalty Vouchers List
export const GET_LOYALTY_VOUCHERS_LIST = "GET_LOYALTY_VOUCHERS_LIST";
export const GET_LOYALTY_VOUCHERS_LIST_SUCCESS =
  "GET_LOYALTY_VOUCHERS_LIST_SUCCESS";
export const GET_LOYALTY_VOUCHERS_LIST_ERROR =
  "GET_LOYALTY_VOUCHERS_LIST_ERROR";

// Loyalty Dashboard Recent Activity List
export const GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST =
  "GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST";
export const GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_SUCCESS =
  "GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_SUCCESS";
export const GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_ERROR =
  "GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_ERROR";

// Search Loyalty Dashboard Report Data
export const SEARCH_LOYALTY_DASHBOARD_REPORT_DATA =
  "SEARCH_LOYALTY_DASHBOARD_REPORT_DATA";
export const SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_SUCCESS =
  "SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_SUCCESS";
export const SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_ERROR =
  "SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_ERROR";

// Create Loyalty Transaction
export const CREATE_LOYALTY_TRANSACTION = "CREATE_LOYALTY_TRANSACTION";
export const CREATE_LOYALTY_TRANSACTION_SUCCESS =
  "CREATE_LOYALTY_TRANSACTION_SUCCESS";
export const CREATE_LOYALTY_TRANSACTION_ERROR =
  "CREATE_LOYALTY_TRANSACTION_ERROR";

// Loyalty Create Voucher Amount
export const CREATE_LOYALTY_VOUCHER_AMOUNT = "CREATE_LOYALTY_VOUCHER_AMOUNT";
export const CREATE_LOYALTY_VOUCHER_AMOUNT_SUCCESS =
  "CREATE_LOYALTY_VOUCHER_AMOUNT_SUCCESS";
export const CREATE_LOYALTY_VOUCHER_AMOUNT_ERROR =
  "CREATE_LOYALTY_VOUCHER_AMOUNT_ERROR";

// Loyalty Redeem Voucher
export const LOYALTY_REDEEM_VOUCHER = "LOYALTY_REDEEM_VOUCHER";
export const LOYALTY_REDEEM_VOUCHER_SUCCESS = "LOYALTY_REDEEM_VOUCHER_SUCCESS";
export const LOYALTY_REDEEM_VOUCHER_ERROR = "LOYALTY_REDEEM_VOUCHER_ERROR";

// VOID Voucher Transaction
export const VOID_VOUCHER_TRANSACTION = "VOID_VOUCHER_TRANSACTION";
export const VOID_VOUCHER_TRANSACTION_SUCCESS =
  "VOID_VOUCHER_TRANSACTION_SUCCESS";
export const VOID_VOUCHER_TRANSACTION_ERROR = "VOID_VOUCHER_TRANSACTION_ERROR";

// Resend Loyalty Voucher EMail
export const RESEND_LOYALTY_VOUCHER_EMAIL = "RESEND_LOYALTY_VOUCHER_EMAIL";
export const RESEND_LOYALTY_VOUCHER_EMAIL_SUCCESS =
  "RESEND_LOYALTY_VOUCHER_EMAIL_SUCCESS";
export const RESEND_LOYALTY_VOUCHER_EMAIL_ERROR =
  "RESEND_LOYALTY_VOUCHER_EMAIL_ERROR";

// Loyalty Single Customer Voucher List
export const LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST =
  "LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST";
export const LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_SUCCESS =
  "LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_SUCCESS";
export const LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_ERROR =
  "LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_ERROR";

// Loyalty Spinner List /loyaltyspinner/list
export const GET_LOYALTY_SPINNER_LIST = "GET_LOYALTY_SPINNER_LIST";
export const GET_LOYALTY_SPINNER_LIST_SUCCESS = "GET_LOYALTY_SPINNER_LIST_SUCCESS";
export const GET_LOYALTY_SPINNER_LIST_ERROR = "GET_LOYALTY_SPINNER_LIST_ERROR";

// Create Loyalty Spinner /loyaltyspinner/create
export const CREATE_LOYALTY_SPINNER = "CREATE_LOYALTY_SPINNER";
export const CREATE_LOYALTY_SPINNER_SUCCESS = "CREATE_LOYALTY_SPINNER_SUCCESS";
export const CREATE_LOYALTY_SPINNER_ERROR = "CREATE_LOYALTY_SPINNER_ERROR";

// Update Loyalty Spinner /loyaltyspinner/update
export const UPDATE_LOYALTY_SPINNER = "UPDATE_LOYALTY_SPINNER";
export const UPDATE_LOYALTY_SPINNER_SUCCESS = "UPDATE_LOYALTY_SPINNER_SUCCESS";
export const UPDATE_LOYALTY_SPINNER_ERROR = "UPDATE_LOYALTY_SPINNER_ERROR";

// Delete Loyalty Spinner /loyaltyspinner/delete
export const DELETE_LOYALTY_SPINNER = "DELETE_LOYALTY_SPINNER";
export const DELETE_LOYALTY_SPINNER_SUCCESS = "DELETE_LOYALTY_SPINNER_SUCCESS";
export const DELETE_LOYALTY_SPINNER_ERROR = "DELETE_LOYALTY_SPINNER_ERROR";

// Get Loyalty Spinner Render Data /loyaltyspinner/render/2
export const GET_LOYALTY_SPINNER_RENDER = "GET_LOYALTY_SPINNER_RENDER";
export const GET_LOYALTY_SPINNER_RENDER_SUCCESS = "GET_LOYALTY_SPINNER_RENDER_SUCCESS";
export const GET_LOYALTY_SPINNER_RENDER_ERROR = "GET_LOYALTY_SPINNER_RENDER_ERROR";

// Get Loyalty Spinner Data /loyaltyspinner/data/2
export const GET_LOYALTY_SPINNER_DATA = "GET_LOYALTY_SPINNER_DATA";
export const GET_LOYALTY_SPINNER_DATA_SUCCESS = "GET_LOYALTY_SPINNER_DATA_SUCCESS";
export const GET_LOYALTY_SPINNER_DATA_ERROR = "GET_LOYALTY_SPINNER_DATA_ERROR";

// Execute Loyalty Spinner /loyaltyspinner/execute
export const EXECUTE_LOYALTY_SPINNER = "EXECUTE_LOYALTY_SPINNER";
export const EXECUTE_LOYALTY_SPINNER_SUCCESS = "EXECUTE_LOYALTY_SPINNER_SUCCESS";
export const EXECUTE_LOYALTY_SPINNER_ERROR = "EXECUTE_LOYALTY_SPINNER_ERROR";
